import gql from 'graphql-tag';

export const REGISTER_PUSH_TOKEN = gql`
  mutation ($pushToken: String!, $appId: String!) {
    registerPushToken(
      pushToken: $pushToken,
      applicationId: $appId,
    ) {
      success
    }
  }
`;

